export default __webpack_public_path__ + "static/media/collaborative-whiteboard.78916c4e.svg";